import React, {useCallback, useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import {useLocation, useNavigate} from 'react-router-dom';
import {SubscriptionForm} from './Components/SubscriptionForm';
import {checkBearerTokenValidity, isRefreshTokenValid} from './Utility/checkToken';
import {GetCurrentSubscriptionCode} from './hooks/hooks';
import {subscribe} from './api/Subscribe';

export const Payment = props => {
  const {state} = useLocation();
  const navigate = useNavigate();
  const userName = useSelector(state => state?.user?.userName);
  const token = useSelector(state => state?.user?.token);
  const trialData = useSelector(state => state?.app.trialData);
  const keyData = useSelector(state => state?.app?.keyData);
  const payluxData = useSelector(state => state?.app?.payluxData);
  const [isCCValid, setCCValid] = useState(true);
  const [formData, setFormData] = useState({
    firstname: '',
    lastname: '',
    cc: '',
    expiryMM: '',
    expiryYY: '',
    cvv: '',
    address1: '',
    address2: '',
    country: '',
    zip: '',
    state: '',
    city: '',
    key: '',
  });

  /* useEffect(() => {
    //check if token is valid
    if (!isRefreshTokenValid()) {
      //logout user
      navigate('/');
    }
  }, []); */

  const handleFormChange = useCallback(
    event => {
      const {target} = event;
      const {name, value} = target;
      setFormData({...formData, [name]: value});
    },
    [formData],
  );

  //intentionally not put callback as it resets the form
  const handleValidation1000 = e => {
    const {target} = e;
    const {name, value} = target;
    if (value < 1000) {
      setFormData({...formData, [name]: value});
    } else {
      console.log('ignored');
    }
  };

  const handleValidation100 = e => {
    const {target} = e;
    const {value} = target;
    if (value < 100) {
      handleFormChange(e);
    } else {
      console.log('ignored');
    }
  };

  const handleSubscribe = (e, PaymentService) => {
    e.preventDefault();
    let subscriptionCode = GetCurrentSubscriptionCode(
      PaymentService,
      trialData,
      payluxData,
      keyData,
    );

    if (PaymentService === 'paylux') {
      //let isCC = require('luhn').validate(formData?.cc);
      //setCCValid(isCC);
      if (formData?.firstname && formData?.lastname /* && isCC */) {
        //subscribe only
        subscribe(formData, userName, navigate, subscriptionCode, PaymentService, token);
      } else {
        console.log('form not valid');
      }
    } else if (PaymentService === 'trial') {
      //console.log('trial', PaymentService, token);
      subscribe(formData, userName, navigate, subscriptionCode, PaymentService, token);
    } else {
      //console.log('key', PaymentService, token, formData?.key);
      subscribe(formData, userName, navigate, subscriptionCode, PaymentService, token);
    }
  };

  return (
    <div className="Auth-form-container">
      <form className="Auth-form">
        <div className="Auth-form-content">
          <h3 className="Auth-form-title">Subscribe to {state?.subscriptionType}</h3>
          {state?.subscriptionType === 'paylux' ? (
            <SubscriptionForm
              formData={formData}
              isCCValid={isCCValid}
              handleFormChange={handleFormChange}
              handleValidation100={handleValidation100}
              handleValidation1000={handleValidation1000}
            />
          ) : null}
          {state?.subscriptionType === 'key' ? (
            <div className="form-group mt-1 d-flex justify-content-center p-1">
              <textarea
                value={formData?.key}
                onChange={handleFormChange}
                name="key"
                id="key"
                type="text"
                className="form-control mt-1"
                placeholder="Provide the key given by vendor"
                rows={6}
                style={{resize: 'none'}}
              />
            </div>
          ) : null}
          <div className="d-grid gap-2 mt-1">
            <button
              type="submit"
              className="btn btn-primary"
              onClick={e => handleSubscribe(e, state?.subscriptionType)}
            >
              Subscribe
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};
